import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

export const canActivateRoute: CanActivateFn = () => {
  const router = inject(Router)

  if (sessionStorage.getItem('previousURL') === 'thankyou') {
    return false
  }
  // Prevent navigating to signup (via browser forward) without email entered
  const userEmail = localStorage.getItem('userEmail')
  if (!userEmail) {
    router.navigateByUrl('/signin')
    return false
  }
  return true
}
